const uploadAudioAndSubtitleActionTypes = {
    OPEN_UPLOAD_AUDIO_AND_SUBTITLE_MODAL: 'OPEN_UPLOAD_AUDIO_AND_SUBTITLE_MODAL',
    UPLOAD_AUDIO_AND_SUBTITLE_COMPLETE: 'UPLOAD_AUDIO_AND_SUBTITLE_COMPLETE',
    CLOSE_UPLOAD_AUDIO_AND_SUBTITLE_MODAL: 'CLOSE_UPLOAD_AUDIO_AND_SUBTITLE_MODAL',
    OPEN_LIST_OF_EXISTED_AUDIO_AND_SUBTITLE: 'OPEN_LIST_OF_EXISTED_AUDIO_AND_SUBTITLE',
    CLOSE_LIST_OF_EXISTED_AUDIO_AND_SUBTITLE: 'CLOSE_LIST_OF_EXISTED_AUDIO_AND_SUBTITLE',
    MODIFY_EXISTED_LANGUAGES: 'MODIFY_EXISTED_LANGUAGES'
}

export default uploadAudioAndSubtitleActionTypes